import { render, staticRenderFns } from "./ExibirPergunta.vue?vue&type=template&id=0933675e&scoped=true&"
import script from "./ExibirPergunta.vue?vue&type=script&lang=js&"
export * from "./ExibirPergunta.vue?vue&type=script&lang=js&"
import style0 from "./ExibirPergunta.vue?vue&type=style&index=0&id=0933675e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933675e",
  null
  
)

export default component.exports